import { Directive, HostListener, inject, output } from '@angular/core';
import { DepositFormOverlayService } from '../deposit/deposit-form-overlay/deposit-form-overlay.service';
import { ProfileService } from '../profile/profile.service';
import { DepositKeywordsSuggestionsService } from './deposit-sections/deposit-keywords/deposit-keywords-suggestions.service';
import { DepositOutputDialogComponent } from './deposit-output-dialog/deposit-output-dialog.component';
import { ConfigurationHandlerService } from '../core/configuration-handler.service';
import { ContentDialogService } from '../parts/dialogs/content-dialog/content-dialog.service';

@Directive({
    selector: '[espDepositFormTrigger]',
    standalone: true,
})
export class DepositFormTriggerDirective {
    private depositFormOverlay = inject(DepositFormOverlayService);
    private profileService = inject(ProfileService);
    private suggestionsService = inject(DepositKeywordsSuggestionsService);
    private configSvc = inject(ConfigurationHandlerService);
    private contentDialogService = inject(ContentDialogService);

    readonly overlayClosed = output<null>();

    @HostListener('click') onClick() {
        if (
            this.configSvc.isCustomerParameterEnabled(
                'esploro_deposit_profiles_conf',
            )
        ) {
            this.contentDialogService.openDialog(
                DepositOutputDialogComponent,
                'research.output.list.add.deposit',
            );
        } else {
            this.launchDepositForm();
        }
    }

    launchDepositForm() {
        this.depositFormOverlay
            .open()
            .afterClosed()
            .subscribe(() => {
                this.overlayClosed.emit(null);
            });
        this.suggestionsService.clearSuggestions();
        this.profileService.retrieveProfileData();
    }
}
